import axios from 'axios';
import grecaptcha from 'grecaptcha';
import {createApp} from 'vue/dist/vue.esm-bundler';
import $ from "jquery";

window.createApp = createApp;

$(function () {
    if ($("#WebshopApp").length === 0) {
        return;
    }

    if ($("#order-summary-mini-table").length > 0) {
        $(window).on('scroll', function () {
            checkCartVisibility();
        });
    }

    function checkCartVisibility() {
        const $products = $("#products");
        const $productHero = $("#product-hero");
        const $summarySmall = $("#order-summary-mini-table");

        let productsHeroOnScreen = $productHero && $productHero.offset() && $productHero.isOnScreen();
        let productsOnScreen = $products && $products.offset() && $products.isOnScreen();

        if (productsHeroOnScreen || productsOnScreen) {
            $summarySmall.fadeIn();
        } else {
            $summarySmall.fadeOut();
        }
    }

    const webshopApp = createApp({
        data: function () {
            return {
                cartExpanded: true,
                locale: 'en-US',
                currency: 'USD',
                isLoadingProductList: true,
                productLists: [],
                company: {
                    CompanyName: '',
                    CompanyNumber: '',
                    Industry: '',
                },
                isSameBillingAddress: true,
                shippingAddress: {
                    FirstName: '',
                    LastName: '',
                    Email: '',
                    AddressLine1: '',
                    AddressLine2: '',
                    PostalCode: '',
                    City: '',
                    Country: '',
                    PhoneNumber: '',
                    IsShippingAddress: true,
                    IsBillingAddress: false,
                },
                billingAddress: {
                    FirstName: '',
                    LastName: '',
                    Email: '',
                    AddressLine1: '',
                    AddressLine2: '',
                    PostalCode: '',
                    City: '',
                    Country: '',
                    PhoneNumber: '',
                    IsShippingAddress: false,
                    IsBillingAddress: true,
                },
                droneInfo: {
                    SerialNumber: this.getQueryParam('sn') ?? '',
                    Model: '',
                    ProblemDescription: '',
                    ZendeskTicketNumber: this.getQueryParam('zd') ?? '',
                },
                comment: '',
                errorMessage: '',
                isSubmitting: false,
                reCaptchaKey: '',
                reCaptchaToken: '',
                productListSlug: '',
            }
        },
        methods: {
            getQueryParam(param) {
                const urlParams = new URLSearchParams(window.location.search);
                return urlParams.get(param) || '';
            },
            incrementBySku: function(productSku) {
                let product = this.productLists.flatMap(p => p.Products).find(p => p.Sku === productSku);
                if (product) {
                    product.Quantity++;
                    this.saveCart();
                    checkCartVisibility();
                }
            },
            increment: function(product) {
                product.Quantity++;
                this.saveCart();
                checkCartVisibility();
            },
            decrement: function(product) {
                if (product.Quantity > 0) {
                    product.Quantity--;
                }
                this.saveCart();
                checkCartVisibility();
            },
            quantityChanged: function() {
                this.saveCart();
                checkCartVisibility();
            },
            toggleCart: function() {
                this.cartExpanded = !this.cartExpanded;
            },
            loadProducts: function() {
                let url = '/Webshop/AvailableProducts'
                axios.get(url)
                    .then(response => {
                        this.isLoadingProductList = false;
                        this.locale = response.data.Locale;
                        this.currency = response.data.Currency;
                        this.productLists = response.data.ProductLists;

                        if (this.currency === 'NOK') {
                            this.shippingAddress.Country = 'NOR';
                            this.billingAddress.Country = 'NOR';
                        }
                        this.loadCart();
                        checkCartVisibility();
                    }).catch(() => {
                        this.isLoadingProductList = false;
                    });
            },
            submitOrder: function (event) {
                event.preventDefault();
                let url = '/Webshop/SubmitOrder';
                const payload = {
                    reCaptchaToken: this.reCaptchaToken,
                    isSameBillingAddress: this.isSameBillingAddress,
                    company: this.company,
                    shippingAddress: this.shippingAddress,
                    billingAddress: this.billingAddress,
                    comment: this.comment,
                    droneInfo: this.droneInfo,
                    productQuantity: {}
                };

                this.productLists.forEach(list => {
                    list.Products.forEach(p => {
                        if (p.Quantity > 0) {
                            payload.productQuantity[p.Sku] = p.Quantity;
                        }
                    });
                });

                this.isSubmitting = true;
                this.errorMessage = '';

                grecaptcha.ready(() => {
                    grecaptcha.execute(this.reCaptchaKey, { action: 'submit_webshop_form' }).then(token => {
                        this.reCaptchaToken = token;
                        payload.reCaptchaToken = token;
                        axios.post(url, payload)
                            .then(response => {
                                if (response.data.Success) {
                                    this.clearCart();
                                    window.location.href = response.data.RedirectUrl;
                                } else {
                                    this.isSubmitting = false;
                                    this.errorMessage = response.data.Message;
                                }
                            })
                            .catch(error => {
                                this.isSubmitting = false;
                                this.errorMessage = error.message;
                                console.warn(error);
                            });
                    }).catch(error => {
                        this.isSubmitting = false;
                        this.errorMessage = error.message;
                    });
                });
            },
            selectedProducts(products) {
                return products.filter(p => p.Quantity > 0);
            },
            formatCurrency(amount) {
                if (typeof amount !== "number") {
                    return amount;
                }
                const formatter = new Intl.NumberFormat(this.locale, {
                    style: 'currency',
                    currency: this.currency,
                });
                return formatter.format(amount);
            },
            saveCart: function() {
                var cart = {}
                this.productLists.forEach(list => {
                    list.Products.forEach(p => {
                        if (p.Quantity > 0) {
                            cart[p.Sku] = p.Quantity;
                        }
                    });
                });
                localStorage.setItem("cart", JSON.stringify(cart));
            },
            loadCart: function() {
                if (localStorage.getItem("cart")) {
                    try {
                        let cart = JSON.parse(localStorage.getItem("cart"));
                        this.productLists.forEach(list => {
                            list.Products.forEach(p => {
                                if (cart.hasOwnProperty(p.Sku)) {
                                    p.Quantity = cart[p.Sku];
                                }
                            });
                        });
                    } catch(e) {
                        localStorage.removeItem("cart");
                    }
                }
            },
            clearCart: function() {
                localStorage.setItem("cart", JSON.stringify({}));
            }
        },
        computed: {
            filteredProductLists: function() {
                if (this.productListSlug) {
                    return this.productLists.filter(p => p.Slug === this.productListSlug);
                } else {
                    return this.productLists;
                }
            },
            companyNameRequired: function () {
                return this.company.CompanyNumber !== '';
            },
            industryRequired: function () {
                return this.company.CompanyNumber !== '' || this.company.CompanyName !== '';
            },
            isServiceOrder: function() {
                return this.productLists.some(l => l.Products.some(p => (p.Sku === 'BYE-SVC-EOW' || p.Sku === 'BYE-SVC-MINI' || p.Sku === 'BYE-SVC-WATER') && p.Quantity > 0));
            },
            productTotal: function () {
                let total = 0;
                this.productLists.forEach(list => {
                    list.Products.forEach(p => {
                        total += (p.Quantity * p.UnitPrice) * p.DiscountLevel;
                    });
                });
                return total;
            },
            shippingTotal: function () {
                let isDomestic = this.shippingAddress.Country === 'NOR';
                let total = 0;
                this.productLists.forEach(list => {
                    list.Products.forEach(p => {
                        total += p.Quantity * (isDomestic ? p.DomesticShippingPrice : p.InternationalShippingPrice);
                    });
                });
                return total;
            },
        },
        mounted() {
            $(document).trigger('vue-loaded');
            if (this.$refs.ReCaptchaKey) {
                this.reCaptchaKey = this.$refs.ReCaptchaKey.value;
            }
            if (this.$refs.ProductListSlug) {
                this.productListSlug = this.$refs.ProductListSlug.value;
            }

            $("#add-to-chart-button").on('click', () => {
                let sku = $("#add-to-chart-button").data('sku');
                this.incrementBySku(sku);
                setTimeout(() => {
                    $("#order-summary-mini-table").fadeIn();
                }, 100);
            });
            this.loadProducts();
        }
    })

    webshopApp.config.compilerOptions.isCustomElement = (tag) => tag.includes('-');
    webshopApp.mount('#WebshopApp');
});